import React, {Component} from 'react'

// Import Scss
import './FreeHeader.scss'

// Import Image
import logo from '../../../../images/logo.png'
import IconFreeCall from '../../../../images/icon-freecall.png'
import BannerFreeCall from '../../../../images/banner-freecall.png'
import BannerFreeCallSM from '../../../../images/banner-freecall-sm.png'


class NavHeader extends Component {
  state = {
    openSlide: false
  }

  toggleSlideOpen = (e) => {
    this.setState(state => ({
      openSlide: !state.openSlide
    }));
  }

  render() {
    return  <div className="header">
      <header id="free-header" className={"free-header " + (this.state.openSlide === true ? "slideOpen" : "")} >
        <div className="headerWrap">
          <div className="headerWrapInner">
            <div className="headerLogoWrap">
              <a href="https://cancer-supporter.jp/treatment/web-second-opinion" className="headerLogo">
                  <img src={logo} alt='Findme（ファインドミー）'  />
              </a>
            </div>
            <div className="rightContents">
              <div className="fwdFreeCall">
                <a href="tel:0120668608">
                  <span className="visibleSP">
                  <img src= {IconFreeCall} alt=""/>
                  </span>
                  <span className="hiddenSP">
                    <img src={BannerFreeCall}  alt="Findme 事務局 0120-668-608 通話無料 平日10:00〜17:00" />
                  </span>
                </a>
              </div>
              <div className="headerButtonWrap">
                <a className="headerSignupButton" href="https://cancer-supporter.jp/treatment/web-second-opinion">
                  <span>はじめる</span>
                </a>
                <a className="headerLoginButton" href="/customer/login/">
                  ログイン
                </a>
              </div>
            </div>
            <div className="headerSlideOpenButtonWrapper" onClick={this.toggleSlideOpen}>
              <div className={"headerSlideOpenButton " + (this.props.openMobileMenu === true ? "slideOpen" : "") } >
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
            <div className="headerSlideMenu">
              <div className="headerSlideLogo">
              </div>
              <nav className="headerNavigation">
                <div className="headerNavigationWrapper headerNavigationWrapperClick">
                  <a href="/so/free/#about">Findmeとは</a>
                  <a href="/so/free/#howto">ご利用の流れ</a>
                  <a href="/so/free/#voice">ご利用者の声</a>
                  <a href="/so/free/faq/" id="faq_nav">Q&amp;A</a>
                  <a href="tel:0120668608" className="visibleSP banner">
                    <img src={BannerFreeCallSM} alt="Findme 事務局 0120-668-608 通話無料 平日10:00〜17:00" />
                  </a>
                </div>
              </nav>
              <div className="headerButtonWrap visibleSP free_headerButtonWrap">
                <a className="headerSignupButton" href="https://cancer-supporter.jp/treatment/web-second-opinion">
                  <span>はじめる</span>
                </a>
                <a className="headerLoginButton headerLoginButtonSP" href="/customer/login/">
                  ログイン
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className={"headerSlideBackDrop " + (this.props.openMobileMenu === true ? "slideOpen" : "") } >
        </div>
      </header>
    </div>
  }
}

export default NavHeader



// WEBPACK FOOTER //
// ./src/components/Header/so/free/nav_header.js